import getEnvironment from "./getEnvironment";

const isDevMode = (): boolean =>
  getEnvironment() === "localhost" && !process.env.VIRTUAL_DOMAIN;

export default isDevMode;
